import React, { Component } from "react";
import { Button, Form, FormGroup, FormControl } from "react-bootstrap";
import { style } from "variables/Variables.jsx";
import NotificationSystem from "react-notification-system";

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
    };
    this.handleWindowShow = this.handleWindowShow.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.sendFeedback = this.sendFeedback.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  handleWindowShow(event) {
    event.preventDefault();
  }

  sendFeedback() {
    this.showNotification("Your Feedback has been received!", "success", 4);
  }

  render() {
    return (
      <div style={{ maxWidth: "95%", margin: "auto", marginTop: "2%" }}>
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="header">
          <h2>Feedback Form</h2>
        </div>
        <div>
          <Form id="feedbackForm" onSubmit={this.handleWindowShow}>
            <FormGroup controlId="formBasicEmail">
              <label>Email address</label>
              <FormControl type="email" placeholder="Enter email" />
              <label className="text-muted">
                We'll never share your email with anyone else.
              </label>
              <br />
              <label>Feedback:</label>
              <FormControl
                type="textarea"
                placeholder="Tell us more!"
                rows="4"
              />
              <Button variant="primary" onClick={this.sendFeedback}>
                Submit
              </Button>
            </FormGroup>
          </Form>
        </div>
      </div>
    );
  }
}

export default Feedback;
